import styled from "styled-components"
import Base from "../base"

const Span = styled(Base)`
    margin: ${props => props.margin ? `${props.margin}` : '0'};
`

export default Span